import { create } from 'zustand';

export const useMapStore = create((set) => ({
  viewState: {
    longitude: 23.7275,
    latitude: 37.9838,
    zoom: 12,
  },
  setViewState: (viewState) => set({ viewState }),
  
  selectedPOI: null,
  setSelectedPOI: (poi) => set({ selectedPOI: poi }),
  
  selectedEvent: null,
  setSelectedEvent: (event) => set({ selectedEvent: event }),
  
  route: null,
  setRoute: (route) => set({ route }),
  
  visibleLayers: {
    metro: true,
    rail: true,
    suburban: true,
    tram: true,
    ev_charger: true,
    parking: true,
    bike_station: true,
  },
  toggleLayer: (layer) => set((state) => ({
    visibleLayers: {
      ...state.visibleLayers,
      [layer]: !state.visibleLayers[layer],
    },
  })),
}));

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('auth_token'),
  user: null,
  isAuthenticated: false,
  
  setAuth: (token, user) => {
    localStorage.setItem('auth_token', token);
    set({ token, user, isAuthenticated: true });
  },
  
  logout: () => {
    localStorage.removeItem('auth_token');
    set({ token: null, user: null, isAuthenticated: false });
  },
}));
